import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';

export const useSendTrackmanParameterCategoryToTranslation = () => {
  const service = useServices().trackmanParameterCategoriesService;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (categoryId: string) => service.sendToTranslation(categoryId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminTrackmanParameterCategories'] });
      notificationsStore.addToast('success', 'Category sent to translation successfully', 'success');
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
